<template>
	<edit-layout @save="handleSave()" @cancel="$emit('browsMode')">
		<el-row type="flex" :gutter="20">
			<el-col class="col" gutter="10">
				<div class="thumb center bg-black-gray2 color-text2" :style="thumbUrl(data.feeling)">
					<span v-if="!thumbUrl(data.feeling)">感受</span>
				</div>
				<el-button @click="openUpload('感受')" type="primary" size="mini">上傳</el-button>
				<p>{{thumbDescription(data.feeling)}}</p>
			</el-col>
			<el-col class="col" gutter="10">
				<div class="thumb center bg-black-gray2 color-text2" :style="thumbUrl(data.imagine)">
					<span v-if="!thumbUrl(data.imagine)">想像</span>
				</div>
				<el-button @click="openUpload('想像')" type="primary" size="mini">上傳</el-button>
				<p>{{thumbDescription(data.imagine)}}</p>
			</el-col>
			<el-col class="col" gutter="10">
				<div class="thumb center bg-black-gray2 color-text2" :style="thumbUrl(data.implement)">
					<span v-if="!thumbUrl(data.implement)">實踐</span>
				</div>
				<el-button @click="openUpload('實踐')" type="primary" size="mini">上傳</el-button>
				<p>{{thumbDescription(data.implement)}}</p>
			</el-col>
			<el-col class="col" gutter="10">
				<div class="thumb center bg-black-gray2 color-text2" :style="thumbUrl(data.share)">
					<span v-if="!thumbUrl(data.share)">分享</span>
				</div>
				<el-button @click="openUpload('分享')" type="primary" size="mini">上傳</el-button>
				<p>{{thumbDescription(data.share)}}</p>
			</el-col>
		</el-row>
		<pictures-dialog :visible.sync="dialogVisible" :title="dialogTitle" />
	</edit-layout>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import PicturesDialog from "@/components/challenge/signUp/editStory/PicturesDialog.vue";
import EditLayout from "./EditLayout.vue";
export default {
	components: { EditLayout, PicturesDialog },
	data() {
		return {
			dialogTitle: "感受",
			dialogVisible: false
		};
	},
	computed: {
		...mapState("story", ["editStoryData"]),
		data() {
			return this.editStoryData.pictures || {};
		}
	},
	methods: {
		...mapActions("story", ["updateStory", "checkProgress"]),
		openUpload(title) {
			this.dialogTitle = title;
			this.dialogVisible = true;
		},
		thumbUrl(arr = []) {
			const item = arr.find(item => item.is_cover);
			const url = item ? item.url : "";
			return url ? `background-image:url(${url})` : "";
		},
		thumbDescription(arr = []) {
			const item = arr.find(item => item.is_cover);
			const description = item ? item.description : "";
			return description ? description : "階段歷程簡述";
		},
		async handleSave() {
			let data = this.editStoryData;
			data.progress = await this.checkProgress();
			await this.updateStory(data);
			this.$emit("browsMode");
			this.$message.success("儲存成功");
		}
	}
};
</script>

<style lang="scss" scoped>
.thumb {
	width: 100%;
	height: 100px;
	background-color: #ececec;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
}
</style>